import React from 'react'

import { FlexContainer, YSpacing, DividerLine } from '@components/common'
import { TooltipModal } from '@components/common/modal'
import { LabelInfo } from '@components/common/form'

import { CrmReadOnlyAccountProfile } from '@types'
import { config } from 'hungry-core2'

interface HubspotFieldsProps {
  account: CrmReadOnlyAccountProfile
  hubspotCompany: {
    id: string
    name: string
  }
}

const HubspotFields: React.FC<HubspotFieldsProps> = ({
  account,
  hubspotCompany,
}) => {
  const valueOrDefault = (value: string | number | null) => {
    if (value === null) {
      return 'N/A'
    }

    return value
  }

  const pEstMonthlyValue = (value: number | null) => {
    if (value === null) {
      return 'N/A'
    }

    return `$${value.toFixed(2)}`
  }

  const pAvgPricePerPerson = (value: string | null, type: string | null) => {
    if (value === null || type === null) {
      return 'N/A'
    }

    return `$${parseFloat(value).toFixed(2)} ${type}`
  }

  const pOrderingFrequency = (value: string | null) => {
    if (value === null) {
      return 'N/A'
    }

    return value === '' ? 'No-cadence / No Pattern' : value
  }

  return (
    <div>
      <DividerLine margin="20px 0" height="1px" width="100%" />
      <p className="font-bold w-full text-center mb-5">
        ** This section of fields must be modified in HubSpot **
      </p>
      <FlexContainer width="100%" justifyContent="space-between">
        <FlexContainer
          width="33%"
          justifyContent="flex-start"
          alignItems="center"
        >
          <a
            className="order-link"
            href={`https://${config.hubspot_url_prefix}/company/${hubspotCompany.id}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {hubspotCompany.name}
          </a>
          <TooltipModal
            unicode="&#9432;"
            width="400px"
            marginTop="20px"
            information="If you need to change the association between this client & the hubspot company, please reach out to the tech team to handle this request."
          />
        </FlexContainer>
        <LabelInfo label="Domain" value={account.domain} width="33%" />
        <LabelInfo
          label="Incumbent"
          value={
            account.incumbent ? account.incumbent.split(';').join(', ') : ''
          }
          width="33%"
        />
      </FlexContainer>
      <YSpacing height="20px" />
      <FlexContainer width="100%" justifyContent="space-between">
        <LabelInfo
          label="Building/Office Population"
          value={valueOrDefault(account.numEmployees).toString()}
          width="33%"
        />
        <LabelInfo
          label="Expected Ordering Headcount"
          value={valueOrDefault(account.expectedOrderingHeadcount).toString()}
          width="33%"
        />
        <LabelInfo
          label="Estimated Monthly Value"
          value={pEstMonthlyValue(account.estimatedMonthlyValue)}
          width="33%"
        />
      </FlexContainer>
      <YSpacing height="20px" />
      <FlexContainer width="100%" justifyContent="space-between">
        <LabelInfo
          label="*Budget Per Person"
          value={pAvgPricePerPerson(
            account.avgPricePerPerson,
            account.avgPricePerPersonType,
          )}
          width="33%"
        />
        <LabelInfo
          label="*FS Client Type"
          value={account.orderingCadence}
          width="33%"
        />
        <LabelInfo
          label="*Ordering Cadence"
          value={pOrderingFrequency(account.orderingFrequency)}
          width="33%"
        />
      </FlexContainer>
      <DividerLine margin="20px 0" height="1px" width="100%" />
    </div>
  )
}

export default HubspotFields
